/* ALVEA — exfoliante capilar. Carrito blindado + deslizador antes/despues. */
(function(){
  var ROOT, PID, V1, V4, V5, VARS = [];

  function money(c){
    /* compacto estilo Drevia: $1,129 (el signo $ ES pesos en MX) */
    var n=c/100;
    var ent=Math.round(n)===n||Math.abs(n-Math.round(n))<0.005;
    try{
      return '$'+(ent?Math.round(n):n).toLocaleString('en-US',{maximumFractionDigits:ent?0:2});
    }catch(e){ return '$'+n.toFixed(ent?0:2); }
  }

  /* ---------- carrito blindado: fuera todo lo que no sea Alvea (o la Proteccion, o el Peine regalo) ---------- */
  var PROT_PID = 15943895253322, PROT_VID = 62857201615178;
  /* peine masajeador de REGALO (5 ago): producto real a $0, entra solo con el pack 2+2 */
  var PEINE_PID = 15950360019274, PEINE_VID = 62889633218890;
  var PEINE_IMG = 'https://cdn.shopify.com/s/files/1/1035/2931/6682/files/alv_peine_oro.jpg?v=1785961092&width=120';
  /* GUIA DIGITAL 28 dias (7 ago): opcional con toggle, NO preactivada (orden Nery).
     Dos variantes reales: suelta $199 MXN / con el pack 2+2 $129 MXN. Sin envio. */
  var GUIA_PID = 15952331473226, GUIA_VID = 62899063423306, GUIA_VID_PACK = 62899089310026;
  /* REGALOS EN CHECKOUT (19 ago, orden Nery): productos reales a $0 con su icono,
     para que las lineas GRATIS se VEAN en el checkout igual que en el drawer.
     SKUs REGALO-* -> ignorados por cj_order_sync. */
  var RG_ENVIO_PID=15978208756042, RG_ENVIO_VID=63001497469258;
  var RG_GARAN_PID=15978208854346, RG_GARAN_VID=63001497600330;
  var RG_TARJ_PID=15978208952650, RG_TARJ_VID=63001497698634;
  var RG_PROT_PID=15978340188490, RG_PROT_VID=63001922994506;
  /* 20 ago (orden Nery): los 2 frascos de REGALO como linea propia a $0,
     con la MISMA foto de frasco, para que el carrito y el checkout se lean solos. */
  var RG_2FR_PID=15983409758538, RG_2FR_VID=63014830211402;
  function alvLimpia(){
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      /* 12 ago: PROT_PID sale de la lista de permitidos -> si un carrito viejo la
         trae guardada, se elimina sola. Asi ningun pedido nuevo llega con ella. */
      var OKPIDS=[String(PID),String(PEINE_PID),String(GUIA_PID),String(RG_ENVIO_PID),String(RG_GARAN_PID),String(RG_PROT_PID),String(RG_2FR_PID)];
      var fuera = c.items.filter(function(i){ return OKPIDS.indexOf(String(i.product_id))===-1; });
      if(!fuera.length) return;
      var upd={};
      fuera.forEach(function(i){ upd[i.key]=0; });
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({updates:upd})});
    }).catch(function(){});
  }
  /* los packs son alternativas, no se suman */
  function alvQuitaPacks(){
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      var mios=c.items.filter(function(i){return String(i.product_id)===String(PID);});
      if(mios.length<2) return;
      var upd={};
      mios.slice(0,-1).forEach(function(i){ upd[i.key]=0; });
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({updates:upd})});
    }).catch(function(){});
  }

  var V3;
  function seleccionado(){
    var el=document.querySelector('.alvPack.on');
    return el? el.getAttribute('data-vid') : V4;
  }

  /* 18 ago: los packs con serum+masajeador muestran el precio TOTAL (pieza a pieza suma en el checkout).
     Los precios del serum/masajeador vienen de data-attrs YA convertidos al mercado (MXN en Mexico). */
  function xtras(){ var r=document.getElementById('alvRoot').dataset; return {ps:+r.pserum||0, cs:+r.cserum||0, pm:+r.pmasaj||0, cm:+r.cmasaj||0}; }
  function conExtras(vid){ return String(vid)===String(V4)||String(vid)===String(V5); }
  /* 28 ago (orden Nery): los packs YA NO llevan masajeador — es opcional a $599 */
  function totalPack(vid){ var v=precio(vid); return v.price; }
  function totalCompare(vid){ var v=precio(vid); return (v.compare||0); }
  function pinta(){
    document.querySelectorAll('.alvPack').forEach(function(p){
      var vid=p.getAttribute('data-vid');
      var v=VARS.filter(function(x){return String(x.id)===String(vid);})[0];
      if(!v) return;
      var b=p.querySelector('.alvP'), s=p.querySelector('.alvPc');
      if(b) b.textContent=money(totalPack(vid));
      if(s) s.textContent=v.compare?money(totalCompare(vid)):'';
    });
    var bp=document.getElementById('alvBarP');
    if(bp) bp.textContent=money(totalPack(seleccionado()));
    /* 21 ago (orden Nery): la barra flotante ensena la foto DEL PACK elegido.
       Antes llevaba siempre la de 1 frasco y confundia en los bundles. */
    var bi=document.getElementById('alvBarImg'), rt=document.getElementById('alvRoot');
    if(bi && rt){
      var _s=String(seleccionado()), _f;
      if(_s===String(V5))      _f=rt.dataset.imgB4;
      else if(_s===String(V4)) _f=rt.dataset.imgB2;
      else                     _f=rt.dataset.imgB1;
      if(_f) bi.src=_f;
    }
    /* 21 ago (orden Nery): la GARANTIA DE 100 DIAS va con los TRES packs.
       Ya no se desbloquea con nada — se acabo el candado. */
    var mo=document.getElementById('alvMasajOpc');
    if(mo) mo.style.display=(String(seleccionado())===String(V5))?'none':'flex';
    var gf=document.getElementById('alvGift');
    if(gf) gf.classList.remove('off');
  }

  function elegir(el){
    masajRegalo=true;
    document.querySelectorAll('.alvPack').forEach(function(p){p.classList.remove('on');});
    el.classList.add('on');
    /* 26 ago (orden Nery): la foto principal YA NO cambia al elegir pack.
       Quedaba mal: la miniatura del bundle sustituia el antes/despues de portada. */
    pinta();
  }

  /* 21 ago: cada pack ensena SU foto arriba — 1 frasco / 2 botes / 4 botes.
     Antes se quedaba siempre la misma imagen y no se veia que llevaba cada opcion. */
  function fotoDelPack(el){
    var root = document.getElementById('alvRoot');
    var main = document.getElementById('alvMain');
    var vid  = document.getElementById('alvMainVid');
    if(!root || !main) return;
    var vid_sel = String(el.getAttribute('data-vid'));
    var src;
    if(vid_sel === String(V5))      src = root.dataset.imgB4 || '';   /* 2+2 GRATIS -> 4 botes */
    else if(vid_sel === String(V4)) src = root.dataset.imgB2 || '';   /* 1 + masajeador -> combo */
    else                            src = root.dataset.imgB1 || '';   /* 1 frasco */
    if(!src) return;
    if(vid) vid.style.display = 'none';
    main.style.display = 'block';
    main.src = src.replace('_300x', '_780x');
    /* la foto del pack es cuadrada: fuera el formato vertical del antes/despues */
    if(main.parentElement) main.parentElement.classList.remove('alvVert');
    document.querySelectorAll('.alvGal img').forEach(function(x){ x.classList.remove('on'); });
  }

  /* ---------- drawer con pila de regalos (estilo Drevia): todo pasa por aqui ---------- */
  var protOn = false;  /* 12 ago: la Proteccion de Envio ya no se cobra ni se anade al carrito */
  var masajRegalo = true; /* 29 ago: el masajeador de regalo del pack 2+2 se puede quitar con la X */
  var masajOn = false; /* 28 ago: masajeador OPCIONAL — se marca en su tarjeta o se quita con la X del carrito */
  var guiaOn = false;   /* la guia se ELIGE, no se pre-marca (7 ago, orden Nery) */
  var packOn = true;    /* si quitan el pack en el drawer, la guia puede comprarse SOLA a $199 */
  function precio(vid){
    var v=VARS.filter(function(x){return String(x.id)===String(vid);})[0];
    return v||{price:0,compare:0};
  }
  function alvDrRender(){
    if(!packOn && !guiaOn){ alvDrVacio(); return; }
    var vid=seleccionado();
    var es4 = packOn && String(vid)===String(V5);
    var es3 = packOn && String(vid)===String(V3); /* 1 frasco + masajeador GRATIS */
    var esM = packOn && (String(vid)===String(V4)||String(vid)===String(V5));
    var v=precio(vid);
    var PROT=4900; /* $49.00 MXN */
    var h='';
    var ahorro=0;
    if(packOn){
    /* cada linea con SU foto: botes solos (17 ago, orden Nery).
       V4 pasa a ser 2 frascos + masajeador -> su linea muestra 2 botes. */
    var root=document.getElementById('alvRoot');
    /* 18 ago: la linea de la crema muestra SOLO los frascos (1 o 4); el serum y el masajeador van en sus propias lineas */
    /* 20 ago: SIEMPRE la foto de un frasco, en los dos packs (orden Nery). */
    var imgSrc = root.dataset.imgB1||'';
    /* linea principal */
    /* 21 ago (orden Nery): UNA linea con el precio del PACK. Antes se desglosaba
       "Frascos 800 + Masajeador 399" y parecia que se cobraba el masajeador aparte. */
    var nomPack, subPack, fotoPack;
    if(es3){       nomPack='1 Frasco ALVEA';       subPack='+ masajeador el&eacute;ctrico de REGALO';        fotoPack=imgSrc; }
    else if(es4){  nomPack='4 Frascos ALVEA';      subPack='2 + 2 GRATIS &middot; tratamiento completo';    fotoPack=root.dataset.imgB4||imgSrc; }
    else if(esM){  nomPack='2 Frascos ALVEA';      subPack='1 + 1 GRATIS &middot; 2 meses';                 fotoPack=root.dataset.imgB2||imgSrc; }
    else{          nomPack='1 Frasco ALVEA';   subPack='exfoliante capilar &middot; 1 mes';                 fotoPack=imgSrc; }
    var totPack = totalPack(vid), cmpPack = totalCompare(vid);
    h+='<div class="alvDrL"><img src="'+fotoPack+'" alt=""><div class="alvDrTx"><b>'+nomPack+'</b><small>'+subPack+'</small></div><div class="alvDrPr">'+(cmpPack>totPack?'<s>'+money(cmpPack)+'</s>':'')+'<b>'+money(totPack)+'</b></div><button class="alvDrX" type="button" onclick="alvQuita(\'pack\')" aria-label="Quitar">&times;</button></div>';
    ahorro=(cmpPack>totPack)?(cmpPack-totPack):0;
    /* 21 ago: los 2 frascos de regalo ya van DENTRO del nombre del pack */

    /* 29 ago (orden Nery): el pack 2+2 lleva el masajeador GRATIS; con 1 frasco es opcional de pago */
    var x=xtras();
    if((es4||es3) && masajRegalo){
      h+='<div class="alvDrL"><div class="alvDrIc"><span class="alvDrFlag">GRATIS</span><img src="'+(root.dataset.imgMasaj||'')+'" alt="Masajeador"></div><div class="alvDrTx"><b>Masajeador El&eacute;ctrico</b><small>4 cabezales &middot; en su caja ALVEA</small></div><div class="alvDrPr"><s>'+money(x.pm)+'</s><b class="free">'+money(0)+'</b></div><button class="alvDrX" type="button" onclick="alvQuita(\'masajregalo\')" aria-label="Quitar">&times;</button></div>';
      ahorro+=x.pm;
    }else if(!es4 && !es3 && masajOn){
      h+='<div class="alvDrL"><img src="'+(root.dataset.imgMasaj||'')+'" alt="Masajeador"><div class="alvDrTx"><b>Masajeador El&eacute;ctrico</b><small>4 cabezales &middot; potencia la exfoliaci&oacute;n</small></div><div class="alvDrPr">'+(x.cm>x.pm?'<s>'+money(x.cm)+'</s>':'')+'<b>'+money(x.pm)+'</b></div><button class="alvDrX" type="button" onclick="alvQuita(\'masaj\')" aria-label="Quitar">&times;</button></div>';
    }

    /* proteccion de envio: GRATIS (12 ago, orden Nery).
       Ya NO es un producto de Shopify: se quedaba sin SKU y dejaba cada pedido
       'parcialmente conectado' en CJ, obligando a conectarlo a mano.
       Ahora es un beneficio incluido mas, con el mismo formato que Envio Gratis. */
    h+='<div class="alvDrL"><div class="alvDrIc"><span class="alvDrFlag">GRATIS</span><img src="'+(root.dataset.protimg||root.dataset.iconProteccion||'')+'" alt=""></div><div class="alvDrTx"><b>Protecci&oacute;n de Env&iacute;o</b><small>Reenv&iacute;o gratis si se pierde o llega da&ntilde;ado</small></div><div class="alvDrPr"><s>'+money(PROT)+'</s><b class="free">'+money(0)+'</b></div></div>';
    ahorro+=PROT;
    } /* fin packOn */
    var GUIA = 0; /* guia eliminada de la oferta (16 ago, orden Nery) */

    if(packOn && !es4){
      h+='<div class="alvDrNudge" onclick="alvDrCambia4()"><b>Cambia al SUPERCOMBO</b>: 4 frascos &mdash; el tratamiento completo de la capa, al mejor precio por frasco. Toca aqu&iacute;.</div>';
    }
    document.getElementById('alvDrB').innerHTML=h;
    var sub=(packOn?totalPack(vid):0) + ((masajOn && !es4)?xtras().pm:0);
    
    document.getElementById('alvDrAho').textContent='-'+money(ahorro);
    document.getElementById('alvDrSub').textContent=money(sub);
    var n=document.getElementById('alvCartN');
    if(n) n.textContent=String((packOn?(es4?4:(esM?2:1)):0)+((((es4||es3)&&masajRegalo)||(!es4&&!es3&&masajOn))?1:0));
  }
  function alvDrVacio(){
    var b=document.getElementById('alvDrB');
    if(b) b.innerHTML='<div class="alvDrVacio">Tu carrito est&aacute; vac&iacute;o.</div>';
    var ah=document.getElementById('alvDrAho'); if(ah) ah.textContent='-'+money(0);
    var su=document.getElementById('alvDrSub'); if(su) su.textContent=money(0);
    var n=document.getElementById('alvCartN'); if(n) n.textContent='0';
    var pg=document.getElementById('alvDrPagar');
    if(pg){ pg.textContent='Seguir comprando'; pg.onclick=function(){ alvDrClose(); alvDrBtnReset(); }; }
  }
  function alvDrBtnReset(){
    var pg=document.getElementById('alvDrPagar');
    if(pg){ pg.textContent='Pagar pedido'; pg.disabled=false; pg.onclick=function(){ window.alvPagar(); }; }
  }
  function alvGuiaCardSync(){
    var c=document.getElementById('alvGuiaCard');
    if(c){ c.classList.toggle('on', guiaOn); c.setAttribute('aria-pressed', guiaOn?'true':'false'); }
    var t=document.getElementById('alvGuiaAdd');
    if(t) t.textContent = guiaOn ? 'Añadida a tu pedido' : 'Toca para añadirla';
  }
  window.alvGuiaCardTgl=function(){ guiaOn=!guiaOn; alvGuiaCardSync(); alvDrRender(); };
  window.alvProtTgl=function(el){ protOn=!!el.checked; alvDrRender(); };
  window.alvGuiaTgl=function(el){ guiaOn=!!el.checked; alvGuiaCardSync(); alvDrRender(); };
  function alvMasajSync(){
    var c=document.getElementById('alvMasajOpc');
    if(c){ c.classList.toggle('on', masajOn); c.setAttribute('aria-pressed', masajOn?'true':'false'); }
  }
  window.alvMasajTgl=function(){ masajOn=!masajOn; alvMasajSync(); alvDrRender(); };
  window.alvQuita=function(que){
    if(que==='masaj'){ masajOn=false; alvMasajSync(); alvDrRender(); return; }
    if(que==='masajregalo'){ masajRegalo=false; alvDrRender(); return; }
    if(que==='prot'){ protOn=false; alvDrRender(); return; }
    if(que==='guia'){ guiaOn=false; alvGuiaCardSync(); alvDrRender(); return; }
    /* quitar el pack: si la guia esta elegida, se queda SOLA a $199; si no, carrito vacio */
    packOn=false;
    alvDrRender();
  };
  window.alvDrCambia4=function(){
    packOn=true;
    var p=document.querySelectorAll('.alvPack');
    p.forEach(function(x){ if(String(x.getAttribute('data-vid'))===String(V5)) elegir(x); });
    alvDrRender();
  };
  window.alvDrClose=function(){ document.getElementById('alvDrOv').style.display='none'; };
  window.alvPagar=function(){
    var b=document.getElementById('alvDrPagar');
    b.textContent='Procesando…'; b.disabled=true;
    var vid=seleccionado();
    if(!packOn){ b.textContent='Pagar pedido'; b.disabled=false; return; }
    /* 17 ago: permalink de carrito = 0 llamadas, reemplaza el carrito y va
       directo al checkout. Los packs con masajeador llevan la linea REGALO
       (variante $0 con su foto) para que el masajeador SE VEA en el checkout. */
    var esM2 = String(vid)===String(V4)||String(vid)===String(V5);
    var root = document.getElementById('alvRoot');
    var vm = root.dataset.vmasaj;
    var vs = root.dataset.vserum;
    var extra = '';
    var es4chk = String(vid)===String(V5) || String(vid)===String(V3);
    if(es4chk && masajRegalo && root.dataset.vmasajregalo) extra += ','+root.dataset.vmasajregalo+':1'; /* regalo $0 en pack 2+2, si no lo han quitado */
    else if(masajOn&&vm) extra += ','+vm+':1';
    /* 20 ago: los 2 frascos de regalo tambien en el checkout (orden Nery) */
    /* 21 ago (orden Nery): fuera la linea '2 Frascos de REGALO' del checkout —
       la foto de 4 frascos ya lo dice. */
    /* 20 ago: el SERUM ya no viaja en ningun pack (orden Nery) */
    /* regalos $0 (19 ago): envio+proteccion SIEMPRE; tarjeta+garantia solo con los packs */
    /* 30 ago (orden Nery): vuelven al checkout las lineas GRATIS de confianza
       (envio, proteccion, garantia). Con 2 lineas de producto ya caben sin tapar nada. */
    /* 4 sep: solo Proteccion de Envio, y el producto PRIMERO (va al final del permalink) */
    /* skip_shop_pay=true (19 ago): SIN desvio a shop.app -> checkout propio, mucho mas rapido */
    window.location.href='/cart/'+RG_PROT_VID+':1'+extra+','+vid+':1?skip_shop_pay=true';
  };
  function agregar(irCheckout){
    packOn=true; /* tocar el CTA del pack = el pack vuelve al pedido */
    alvDrBtnReset();
    alvDrRender();
    document.getElementById('alvDrOv').style.display='flex';
  }
  window.alvCartOpen=function(){ alvDrBtnReset(); alvDrRender(); document.getElementById('alvDrOv').style.display='flex'; };

  /* 13 ago (orden Nery): CONTADOR ELIMINADO. La barra verde que lo llevaba
     ahora muestra el nombre del pack en blanco ("COMPRA 1 + 1 GRATIS" /
     "COMPRA 2 + 2 GRATIS"). A Nery le gustaba la estructura de la barra, no
     el reloj. Se quita tambien la clave sessionStorage 'alvOfertaFin'. */

  /* ---------- deslizador antes / despues ---------- */
  function initSlider(){
    var w=document.getElementById('alvBA');
    if(!w) return;
    var top=w.querySelector('.alvBA-top'), han=w.querySelector('.alvBA-han');
    var arr=false;
    function set(p){
      p=Math.max(0,Math.min(100,p));
      top.style.clipPath='inset(0 '+(100-p)+'% 0 0)';
      han.style.left=p+'%';
    }
    function desde(e){
      var r=w.getBoundingClientRect();
      var cx=(e.touches&&e.touches[0]?e.touches[0].clientX:e.clientX);
      set(((cx-r.left)/r.width)*100);
    }
    w.addEventListener('mousedown',function(e){arr=true;desde(e);});
    w.addEventListener('touchstart',function(e){arr=true;desde(e);},{passive:true});
    window.addEventListener('mousemove',function(e){if(arr)desde(e);});
    window.addEventListener('touchmove',function(e){if(arr)desde(e);},{passive:true});
    window.addEventListener('mouseup',function(){arr=false;});
    window.addEventListener('touchend',function(){arr=false;});
    set(50);
  }


  /* ---------- galeria: clic cambia la imagen principal ---------- */
  function initGaleria(){
    var main = document.getElementById('alvMain');
    var vid  = document.getElementById('alvMainVid');
    if(!main) return;
    document.querySelectorAll('.alvGal img').forEach(function(t){
      t.addEventListener('click', function(){
        document.querySelectorAll('.alvGal img').forEach(function(x){x.classList.remove('on');});
        t.classList.add('on');
        var wrap = main.parentElement;
        if(t.dataset.video){
          if(vid){ vid.style.display='block'; vid.removeAttribute('poster'); var src=vid.querySelector('source');
                   if(src && src.src!==t.dataset.video){src.src=t.dataset.video; vid.load();}
                   vid.play().catch(function(){}); }
          main.style.display='none';
          if(wrap) wrap.classList.remove('alvVert');
        }else{
          if(vid) vid.style.display='none';
          main.style.display='block';
          main.src = t.src;
          /* el antes/despues es vertical: el contenedor se adapta para no recortarlo */
          if(wrap) wrap.classList.toggle('alvVert', t.src.indexOf('alv_antes_despues') !== -1);
        }
      });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(){
    document.querySelectorAll('.alvFaqQ').forEach(function(q){
      q.addEventListener('click',function(){
        var it=q.parentElement;
        it.classList.toggle('open');
      });
    });
  }

  function init(){
    ROOT=document.getElementById('alvRoot');
    if(!ROOT) return;
    PID=ROOT.getAttribute('data-pid');
    V1=ROOT.getAttribute('data-v1');
    V4=ROOT.getAttribute('data-v4');
    V5=ROOT.getAttribute('data-v5');
    V3=ROOT.getAttribute('data-v3'); /* 7 sep: 1 frasco + masajeador GRATIS */
    try{ VARS=JSON.parse(ROOT.getAttribute('data-vars')||'[]'); }catch(e){ VARS=[]; }
    pinta();
    var hoy=document.getElementById('alvHoy');
    if(hoy){ var d=new Date(); hoy.textContent=('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2); }
    initSlider();
    initFaq();
    initGaleria();
    var ov=document.getElementById('alvDrOv');
    if(ov) ov.addEventListener('click',function(e){ if(e.target===ov) alvDrClose(); });
    try{ alvDrRender(); }catch(e){}
  }

  document.addEventListener('click',function(e){
    var p=e.target.closest('.alvPack'); if(p){ elegir(p); return; }
    if(e.target.closest('.alvAdd')){ e.preventDefault(); agregar(false); return; }
    if(e.target.closest('.alvBuy')){ e.preventDefault(); agregar(true); return; }
  });

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  /* Al volver con el boton ATRAS el navegador restaura la pagina desde cache (bfcache)
     y los botones se quedaban congelados en "Procesando...". Se resetean todos. */
  function alvResetBotones(){
    document.querySelectorAll('.alvAdd,.alvBuy').forEach(function(b){ b.disabled=false; });
    alvDrBtnReset();
  }
  window.addEventListener('pageshow', alvResetBotones);
  window.addEventListener('popstate', alvResetBotones);
  document.addEventListener('visibilitychange',function(){
    if(!document.hidden) alvResetBotones();
  });
})();
